import { RG_TYPE } from "@project-rouge/rg-core";
import { getRgObjectsOfType } from "@project-rouge/rg-three";
import { AggBuildingFromAnatomyNmcs } from "./index188.js";
import { getActiveZones } from "./index186.js";
const pipeAggNmcs = ([parent, { aggProps, buildingIds }]) => {
  const dataset = aggProps.dataset;
  const zones = getActiveZones(parent, aggProps);
  for (const zone of zones) {
    const aggZoneProps = aggProps.zones[zone.uuid];
    const buildings = getRgObjectsOfType(zone, RG_TYPE.Building);
    for (const building of buildings) {
      if (buildingIds && !buildingIds.includes(building.uuid))
        continue;
      AggBuildingFromAnatomyNmcs({ building, aggZoneProps, dataset });
    }
  }
  return [parent, void 0];
};
export {
  pipeAggNmcs
};
//# sourceMappingURL=index98.js.map
